<template>
	<nav :class="`navbar navbar-expand-lg navbar-light fixed-top py-3 ${id == 'HomePage' ?  '':'navbar-shrink'}`"
		id="mainNav">
		<div class="container px-4 px-lg-5">
			<div id="homePage">
				<router-link to="/" class="navbar-brand">首页</router-link>
			</div>
			<button class="navbar-toggler navbar-toggler-right" type="button" data-bs-toggle="collapse"
				data-bs-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false"
				aria-label="Toggle navigation">
				<span class="navbar-toggler-icon"></span>
			</button>
			<div class="collapse navbar-collapse" id="navbarResponsive">
				<ul class="navbar-nav ms-auto my-2 my-lg-0">
					<li class="nav-item"  v-for="(item, key) in name"
						:key="key">
						<router-link :style = "id == assembly[key + 1]?color:''" class="nav-link" :to=" '/' + assembly[key + 1]">{{ item }}</router-link>
					</li>
				</ul>
			</div>
		</div>
	</nav>
</template>

<script>
	import data from "../data/data.json"
	export default {
		name: "Navigation",
		data() {
			return {
				color: {
					color: "#f4623a",
				},
				assembly: data.page.assembly,
				name: data.page.name,
				id: this.$route.name
			};
		},
		watch: {
			$route(to) {
				this.id = to.name;
			}
		},
		mounted() {
			const navbarToggler = document.body.querySelector(".navbar-toggler");
			const navbarResponsive = document.getElementById("navbarResponsive");
			const responsiveNavItems = [].slice.call(
				document.querySelectorAll("#navbarResponsive .nav-link")
			);
			responsiveNavItems.map((responsiveNavItem) => {
				responsiveNavItem.addEventListener("click", () => {
					if (window.getComputedStyle(navbarToggler).display !== "none") {
						navbarToggler.click();
					}
				});
			});
			const homePage = document.getElementById("homePage");
			homePage.addEventListener("click", () => {
				if (window.getComputedStyle(navbarToggler).display !== "none") {
					if (window.getComputedStyle(navbarResponsive).display !== "none") {
						navbarToggler.click();
					}
				}
			})
		},
	};
</script>

<style scoped>
	.nav-item,
	.navbar-brand {
		cursor: pointer;
	}
</style>
